import axios from "../utils/axios";

export const getTestimonials = async (params) => {
    const { data } = await axios.get("/testimonials", { params });
    return data;
};

export const getTestimonialById = async (id) => {
    const { data } = await axios.get(`/testimonials/${id}`);
    return data;
};

export const createTestimonial = async (itemData) => {
    const { data } = await axios.post("/testimonials", itemData);
    return data;
};

export const updateTestimonial = async (id, itemData) => {
    const { data } = await axios.put(`/testimonials/${id}`, itemData);
    return data;
};

export const deleteTestimonial = async (id) => {
    const { data } = await axios.delete(`/testimonials/${id}`);
    return data;
};

export const forceDeleteTestimonial = async (id) => {
    const { data } = await axios.delete(`/testimonials/${id}/force`);
    return data;
};

export const restoreTestimonial = async (id) => {
    const { data } = await axios.post(`/testimonials/${id}/restore`);
    return data;
};

export const massDestroyTestimonials = async (data) => {
    const response = await axios.delete("/testimonials/mass-destroy", { data });
    return response.data;
};

export const massForceDeleteTestimonials = async (data) => {
    const response = await axios.delete("/testimonials/mass-force-delete", { data });
    return response.data;
};

export const massRestoreTestimonials = async (data) => {
    const response = await axios.post("/testimonials/mass-restore", data);
    return response.data;
};
